import useCollection from '@utilities/hooks/useCollection/useCollection';
import { Unit } from '@data/unit/Unit';
import { ENDPOINT_USER_UNITS } from '@utilities/apiConstants';
import { useMemo } from 'react';

export const useGetTimeZoneByHospital = () => {
	const units = useCollection<Unit>(ENDPOINT_USER_UNITS);

	return useMemo(() => {
		return units.reduce<{ [key: string]: string }>((acc, unit) => {
			acc[unit.hospitalName] = unit.hospitalTimeZone;
			return acc;
		}, {});
	}, [units]);
};
